<template lang="pug">
v-stepper(v-model="step")
  v-stepper-items
    v-stepper-content(step="1")
      v-data-table(
        dense,
        hide-default-footer,
        :headers="headers",
        :loading="loading",
        loading-text="Proses mengambil data .....",
        no-data-text="Data tidak ditemukan .....",
        no-results-text="Data tidak ditemukan .....",
        :items="listData",
        :page.sync="page",
        :items-per-page="itemsPerPage",
        @page-count="pageCount = $event",
        :search="criteria"
      )
        template(v-slot:top)
          v-container(grid-list-md)
            v-layout(wrap, menu-btn)
              v-flex(lg2, md2, xs12)
                v-btn.my-1(color="info", @click="step = '2'") Tambahkan Data
              v-spacer
              v-flex(lg5, md5, xs12)
                v-text-field(
                  dense,
                  v-model="criteria",
                  label="Filter Data Pencarian",
                  prepend-icon="mdi-magnify",
                  clearable
                )
        template(v-slot:item.action="{ item }")
          v-layout(wrap, justify-center, menu-btn-sm, my-1)
            f-button-option(:check="transactionForm" :del="true" v-on:check="doSet(item)" v-on:delete="doRemove(item)")
      .text-xs-center.ma-2
        v-pagination(v-model="page", :length="pageCount")
      .ma-2.menu-btn(v-if="transactionForm")
        v-btn.mx-1(@click="doCancel") Kembali
          v-icon mdi-arrow-left
    v-stepper-content(step="2")
      f-transfer-internal-list-form(
        v-if="productId && (productId == 'TRF_INT' || productId == 'MLT_TRF_INT')",
        :productId="productId",
        :productGroup="productGroup",
        v-on:cancel="doReset",
        v-on:list="setTransactionList"
      )
      f-transfer-online-list-form(
        v-else-if="productId && (productId == 'TRF_ONL' || productId == 'TRF_BIF')",
        :productId="productId",
        :productGroup="productGroup",
        v-on:cancel="doReset",
        v-on:list="setTransactionList"
      )
      f-transfer-external-list-form(
        v-else-if="productId && (productId == 'SKN' || productId == 'RTGS')",
        :productId="productId",
        :productGroup="productGroup",
        v-on:cancel="doReset",
        v-on:list="setTransactionList"
      )
      f-payment-list-form(
        v-else-if="productId && productId == 'PLN_PRE'",
        :productId="productId",
        :productGroup="productGroup",
        v-on:cancel="doReset",
        v-on:list="setTransactionList"
      )
      f-payment-pstn-list-form(
        v-else-if="productId && productId == 'PSTN'",
        :productId="productId",
        :productGroup="productGroup",
        v-on:cancel="doReset",
        v-on:list="setTransactionList"
      )
      f-payment-list-form(
        v-else-if="productGroup && productGroup.includes('PAYMENT')",
        :productId="productId",
        :productGroup="productGroup",
        v-on:cancel="doReset",
        v-on:list="setTransactionList"
      )
      f-payment-multi-list-form(
        v-else-if="productGroup && productGroup.includes('MULTI_PYM')",
        :productId="productId",
        :productGroup="productGroup",
        :merchantId="merchantId",
        v-on:cancel="doReset",
        v-on:list="setTransactionList"
      )
      f-purchase-list-form(
        v-else-if="productGroup && productGroup.includes('PURCHASE')",
        :productId="productId",
        :productGroup="productGroup",
        v-on:cancel="doReset",
        v-on:list="setTransactionList"
      )
      f-default-list-form(
        v-else,
        :productId="productId",
        :productGroup="productGroup",
        v-on:cancel="doReset",
        v-on:list="setTransactionList"
      )
</template>
<script>
export default {
  name: "FTransactionListStepper",
  props: ["productId", "productGroup", "transactionForm", "merchantId"],
  data() {
    return {
      userDetail: null,
      loading: false,
      criteria: "",
      headers: [],
      page: 1,
      itemsPerPage: 5,
      pageCount: 0,
      step: "1",
      listData: [],
      transactionList: {},
    };
  },
  mounted() {
    this.$session.userDetail().then((item) => {
      this.userDetail = item || null;
      this.doReset();
    });
  },
  watch: {
    productId(val) {
      this.doReset();
    },
    merchantId(val) {
      if (val) {
        this.doReset();
      }
    },
  },
  methods: {
    doReset() {
      this.setHeader();
      if (this.userDetail) {
        this.transactionList = {
          corporateId: this.userDetail.corporate.corporateId,
          corporateGroupId:
            this.userDetail.corporate.corporateGroup.corporateGroupId,
        };
      }
      this.criteria = "";
      this.page = 1;
      this.pageCount = 0;
      this.loading = false;
      this.step = "1";
      this.listData = [];
      this.doLoad();
    },
    doLoad() {
      if (this.productId) {
        this.loading = true;
        this.$http
          .get("/api/system/transaction-list/by-product", {
            params: {
              corporateId: this.userDetail.corporate.corporateId,
              corporateGroupId:
                this.userDetail.corporate.corporateGroup.corporateGroupId,
              productId: this.productId,
            },
          })
          .then((success) => {
            this.listData = success.data;
            if (this.merchantId) {
              this.listData = this.listData.filter(
                (f) => f.data && f.data.merchantId == this.merchantId
              );
            }
          })
          .finally(() => (this.loading = false));
      }
    },
    setTransactionList(dataTrx) {
      if (this.isExist(dataTrx.customerId)) {
        this.$message.error("Tujuan transaksi telah terdaftar.");
      } else {
        this.transactionList.customerId = dataTrx.customerId;
        this.transactionList.description = dataTrx.description;
        this.transactionList.productId = this.productId;
        this.transactionList.data = dataTrx.data;

        this.doSave();
      }
    },
    isExist(data) {
      let result = null;
      this.listData.map((element) => {
        if (data === element.customerId) {
          result = element;
        }
      });
      return result;
    },
    doSave() {
      this.$progress.show(true);
      this.$http
        .post("/api/system/transaction-list", this.transactionList)
        .then(
          (success) => {
            this.$message.success("Data berhasil disimpan");
            this.doReset();
          },
          (err) => {
            this.$message.error(err.response.data.message);
          }
        )
        .finally(() => this.$progress.show(false));
    },
    doRemove(data) {
      this.$progress.show(true);
      this.$http
        .delete("/api/system/transaction-list", {
          params: {
            corporateId: data.corporateId,
            corporateGroupId: data.corporateGroupId,
            productId: data.productId,
            customerId: data.customerId,
          },
        })
        .then(
          (success) => {
            this.$message.success("Data berhasil dihapus");
            this.doReset();
          },
          (err) => {
            this.$message.error(err.response.data.message);
          }
        )
        .finally(() => this.$progress.show(false));
    },
    doCancel() {
      this.$emit("cancel");
    },
    doSet(item) {
      this.$emit("data", item);
    },
    setHeader() {
      if (
        this.productId &&
        (this.productId == "TRF_INT" || this.productId == "MLT_TRF_INT")
      ) {
        this.headers = [
          {
            text: "No. Rekening",
            value: "customerId",
            sortable: false,
            width: "140px",
            class: "primary--text",
          },
          {
            text: "Atas Nama",
            value: "description",
            sortable: false,
            class: "primary--text",
          },
          {
            text: "",
            value: "action",
            sortable: false,
            width: "100px",
            align: "center",
            class: "success--text",
          },
        ];
      } else if (
        this.productId &&
        (this.productId == "TRF_ONL" || this.productId == "TRF_BIF")
      ) {
        this.headers = [
          {
            text: "Bank Tujuan",
            value: "data.bankName",
            sortable: false,
            width: "150px",
            class: "primary--text",
          },
          {
            text: "No. Rekening",
            value: "customerId",
            sortable: false,
            width: "140px",
            class: "primary--text",
          },
          {
            text: "Atas Nama",
            value: "description",
            sortable: false,
            class: "primary--text",
          },
          {
            text: "",
            value: "action",
            sortable: false,
            width: "150px",
            align: "center",
            class: "success--text",
          },
        ];
      } else if (
        this.productId &&
        (this.productId == "SKN" || this.productId == "RTGS")
      ) {
        this.headers = [
          {
            text: "Bank Tujuan",
            value: "data.dest.bankName",
            sortable: false,
            width: "150px",
            class: "primary--text",
          },
          {
            text: "No. Rekening",
            value: "customerId",
            sortable: false,
            width: "140px",
            class: "primary--text",
          },
          {
            text: "Atas Nama",
            value: "description",
            sortable: false,
            class: "primary--text",
          },
          {
            text: "",
            value: "action",
            sortable: false,
            width: "150px",
            align: "center",
            class: "success--text",
          },
        ];
      } else if (this.productId && this.productId == "PLN_PRE") {
        this.headers = [
          {
            text: "No. Pelanggan",
            value: "customerId",
            sortable: false,
            width: "140px",
            class: "primary--text",
          },
          {
            text: "Nama Pelanggan",
            value: "description",
            sortable: false,
            class: "primary--text",
          },
          {
            text: "",
            value: "action",
            sortable: false,
            width: "150px",
            align: "center",
            class: "success--text",
          },
        ];
      } else if (this.productId && this.productId == "PSTN") {
        this.headers = [
          {
            text: "Kode Area",
            value: "data.areaCode",
            sortable: false,
            width: "80px",
            class: "primary--text",
          },
          {
            text: "No. Pelanggan",
            value: "customerId",
            sortable: false,
            width: "140px",
            class: "primary--text",
          },
          {
            text: "Nama Pelanggan",
            value: "description",
            sortable: false,
            class: "primary--text",
          },
          {
            text: "",
            value: "action",
            sortable: false,
            width: "150px",
            align: "center",
            class: "success--text",
          },
        ];
      } else if (this.productGroup && this.productGroup.includes("PAYMENT")) {
        this.headers = [
          {
            text: "No. Pelanggan",
            value: "customerId",
            sortable: false,
            width: "140px",
            class: "primary--text",
          },
          {
            text: "Nama Pelanggan",
            value: "description",
            sortable: false,
            class: "primary--text",
          },
          {
            text: "",
            value: "action",
            sortable: false,
            width: "150px",
            align: "center",
            class: "success--text",
          },
        ];
      } else if (this.productGroup && this.productGroup.includes("PURCHASE")) {
        this.headers = [
          {
            text: "No. Handphone",
            value: "customerId",
            sortable: false,
            width: "140px",
            class: "primary--text",
          },
          {
            text: "Keterangan",
            value: "description",
            sortable: false,
            class: "primary--text",
          },
          {
            text: "",
            value: "action",
            sortable: false,
            width: "150px",
            align: "center",
            class: "success--text",
          },
        ];
      } else if (this.productGroup && this.productGroup.includes("MULTI_PYM")) {
        this.headers = [
          {
            text: "No. Virtual Account",
            value: "customerId",
            sortable: false,
            width: "140px",
            class: "primary--text",
          },
          {
            text: "Nama Virtual Account",
            value: "description",
            sortable: false,
            class: "primary--text",
          },
          {
            text: "",
            value: "action",
            sortable: false,
            width: "150px",
            align: "center",
            class: "success--text",
          },
        ];
      } else {
        this.headers = [
          {
            text: "Tujuan Transaksi",
            value: "customerId",
            sortable: false,
            width: "140px",
            class: "primary--text",
          },
          {
            text: "Keterangan",
            value: "description",
            sortable: false,
            class: "primary--text",
          },
          {
            text: "",
            value: "action",
            sortable: false,
            width: "150px",
            align: "center",
            class: "success--text",
          },
        ];
      }
    },
  },
};
</script>